export const IRRELEVANT_DETAILS = ['Packing Condition', 'Not Packed'];
